declare var App;
import Portal = require("portal-gis");
import _ = require("underscore");
import Utils = require("../utils");
import Services = require("../services/services");
import IPS = require("publicsector");
import $ = require("jquery");

function render(feature: Rhythm.GIS.FeatureQueryResultFeature, args: {
    symbol: Portal.MonikerSymbologyElement;
    layerOptions: Rhythm.GIS.Dictionary<string>;
    commands?: () => HTMLElement;
}) {
    let label = args.symbol ? _.template(args.symbol.Label)(feature.attributes) : "";

    let fieldList = args.layerOptions["field-list"] ? Utils.split(args.layerOptions["field-list"]) : [""];
    let showLabels = args.layerOptions["show-labels"] === "true";
    let fieldLabelMap = [];
    if (showLabels) {
        let fieldLabels = args.layerOptions["field-labels"] ? Utils.split(args.layerOptions["field-labels"]).map(v => v.trim()) : fieldList;
        fieldList.forEach((id, i) => fieldLabelMap[id] = fieldLabels[i]);
    }

    let keys = Object.keys(feature.attributes);

    let details = "";
    // preserves field order limited to valid keys
    if (Array.isArray(fieldList)) {

        let isVisible = d => typeof d in { string: 1, number: 1 };

        let doit = (showLoading = false) => {
            let fieldData = fieldList.map(k => ({ id: k, data: Utils.data(feature.attributes, k) }));
            details = fieldData
                .map(k => {
                    let visible = isVisible(k.data);
                    return `<tr class='${k.id} ${visible ? "" : showLoading ? "loading" : "hidden"}'><td><label class='name ${!showLabels ? "hidden" : ""}'>${fieldLabelMap[k.id] || k.id}</label></td><td><label class='value'>${visible ? k.data : ""}</label></td></tr>`;
                })
                .join('');

            let header = `<section class="header"><h3 class="project-title">${label}</h3></section>`;
            let body = `<section class="body"><table class='infoviewer-grid'><tbody>${details}</tbody></table></section>`;
            let footer = $(`<section class="footer"></section>`);
            if (args.commands) footer.append(args.commands());

            return $("<div>").append(header).append(body).append(footer);
        };

        if (!args.layerOptions["join-query-service"] || !args.layerOptions["join-query-service-template"]) {
            return doit()[0];
        } else {
            let dom = doit(true);

            let queryService = args.layerOptions["join-query-service"];
            let queryTemplate = args.layerOptions["join-query-service-template"];

            let filter = _.template(queryTemplate)(feature.attributes);

            let service = new Services.BusinessService<IPS.GeoEntity>({
                query: {
                    query: filter,
                    merge: true
                }
            }, queryService);

            service.each()
                .done(results => {
                    if (!results.length) {
                        $(`table.infoviewer-grid tbody tr.loading`, dom).addClass("hidden").removeClass("loading");
                    }
                    results.forEach(item => {
                        Object.keys(item)
                            .forEach(k => {
                                let value = item[k];
                                let visible = isVisible(value);
                                $(`table.infoviewer-grid tbody tr.${k}`, dom)
                                    .each((i, n) => {
                                        $("label.value", n)
                                            .each((i, n) => {
                                                n.innerHTML = visible ? value : "";
                                            })
                                            .removeClass("loading");
                                    })
                                    .removeClass("loading")
                                    .toggleClass("hidden", !visible);
                                feature.attributes[k] = item[k];
                            });
                    });

                    // value just isn't coming or considered visible (undefined or non-number, non-string)
                    $(`table.infoviewer-grid tbody tr.loading`, dom)
                        .addClass("hidden");

                })
                .fail(() => {
                    $(`table.infoviewer-grid tbody tr.loading`, dom)
                        .addClass("failure");
                });
            ;

            return dom[0];
        }
    }

}


export =render;
